if (!customElements.get('trd-home-counters')) {
  customElements.define('trd-home-counters', class extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-count]'));
      this.finish = () => this.items.forEach(el => { el.textContent = el.dataset.count; });
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => { if (this.motion.matches) { cancelAnimationFrame(this.frame); this.observer?.disconnect(); this.finish(); } };
      this.motion.addEventListener('change', this.onMotionChange);
      if (this.motion.matches || !('IntersectionObserver' in window)) { this.finish(); return; }
      this.items.forEach(el => { el.textContent = '0'; });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        let start;
        const tick = now => {
          if (!this.isConnected) return;
          if (start === undefined) start = now;
          const progress = Math.min((now - start) / 1400, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.items.forEach(el => { el.textContent = Math.round(Number(el.dataset.count) * eased); });
          if (progress < 1) this.frame = requestAnimationFrame(tick);
          else this.finish();
        };
        this.frame = requestAnimationFrame(tick);
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.motion?.removeEventListener('change', this.onMotionChange);
    }
  });
}
